import { Wrapper, Title, Subtitle } from './styles'
import { DescriptionProps } from './types'

export function Description({
  title = '',
  subtitle = '',
  titleAs = 'h2',
  titleAdditionalStyles,
  wrapperAdditionalStyles,
}: DescriptionProps) {
  return (
    <Wrapper wrapperAdditionalStyles={wrapperAdditionalStyles}>
      {title && (
        <Title as={titleAs} titleAdditionalStyles={titleAdditionalStyles}>
          {title}
        </Title>
      )}
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </Wrapper>
  )
}
